import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { WS_ACTION_TYPES, POI_ACTION_TYPES } from '../../redux-saga/actionTypes';
import { commands } from '../../constants/index';
import styles from './styles';

const { goNowCommand } = commands;

const GoNow = ({
  t,
  classes,
  sendMessageToSocket,
  routeInProgress,
  markSinglePoi,
  markPoiList,
  quicklinksInprogress,
}) => {
  const handleOnClick = () => {
    markSinglePoi(false);
    markPoiList(false);
    sendMessageToSocket(goNowCommand);
    routeInProgress(true);
    quicklinksInprogress(false);
  };

  return (
    <React.Fragment>
      <Button onClick={handleOnClick} className={classes.container}>
        <Typography className={classes.goNow__text}>
          {t('poi-details.label.action-button.go-now')}
        </Typography>
      </Button>
    </React.Fragment>
  );
};

GoNow.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  sendMessageToSocket: PropTypes.func.isRequired,
  routeInProgress: PropTypes.func.isRequired,
  markSinglePoi: PropTypes.func.isRequired,
  markPoiList: PropTypes.func.isRequired,
  quicklinksInprogress: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => ({
  sendMessageToSocket: payload => dispatch({ type: WS_ACTION_TYPES.WS.ON_COMMANDS, payload }),
  routeInProgress: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.ROUTE_INPROGRESS, payload }),
  markSinglePoi: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.SINGLE_POI, payload }),
  markPoiList: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.POI_LIST_INPROGRESS, payload }),
  quicklinksInprogress: payload =>
    dispatch({ type: POI_ACTION_TYPES.NAVIGATION_STATE.QUICKLINKS_INPROGRESS, payload }),
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(GoNow)),
);
